import { useState } from "react";
import styles from "./AllCourses.module.css";
import data from "../../data";
import CourseCard from "./CourseCard";
import Category from "./Categories";

const allCategories = ["All", ...new Set(data.map((item) => item.category))];

const AllCourses = () => {
  const [courses, setCourses] = useState(data);
  const [categories, setCategories] = useState(allCategories);
  const [searchTerm, setSearchTerm] = useState("");

  //Filter Courses
  const filterItems = (category) => {
    if (category === "All") {
      setCourses(data);
      return;
    }
    const newItems = data.filter((item) => item.category === category);
    setCourses(newItems);
  };

  //Search Courses
  const searchForm = () => {
    const newItem = data.filter((item) =>
      item.title.toLowerCase().includes(searchTerm)
    );
    if (searchTerm.trim()) {
      setCourses(newItem);
    }
  };

  const handleChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const onSubmit = (e) => {
    e.preventDefault();
    searchForm();
    setSearchTerm("");
  };

  const clearSearch = () => {
    setCourses(data);
  };

  return (
    <div>
      <div className="section">
        <div className={styles.CoursesContainer}>
          <div className={styles.categoryContainer}>
            <div className={styles.category}>Category</div>
            <Category categories={categories} filterItems={filterItems} />
          </div>
          <div className={styles.coursesSearch}>
            <div className={styles.search}>
              <form className={styles.formContainer} onSubmit={onSubmit}>
                <input
                  type="text"
                  name="search"
                  placeholder="search..."
                  value={searchTerm}
                  onChange={handleChange}
                />
                <button type="submit" className={styles.formBtn}>
                  Search
                </button>
              </form>
            </div>
            <div className={styles.courses}>
              <CourseCard className={styles.courses} items={courses} />
              {courses.length < 1 ? (
                <div>
                  <div className={styles.noCourses}>
                    <div className={styles.noCoursesText}>
                      Sorry we don't have any courses that match your search.
                      Try to enter a new search term.
                    </div>
                    <button className="primary-btn" onClick={clearSearch}>
                      All Courses
                    </button>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AllCourses;
